// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LDj7","placeholdersHeader":"styles_placeholdersHeader__2uBnZ","editorStyle":"styles_editorStyle__g7zMD","placeholdersBox":"styles_placeholdersBox__3Nca3"};